import React from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  setDisease,
  setStepOneSelectedDiseases,
} from '../redux/selfDiagnosisActions';

const useStyles = makeStyles(() => ({
  input: {
    boxSizing: 'border-box',
    maxWidth: '500px',
    borderRadius: 5,
    border: '1px solid gray',
    padding: '10px 15px',
    color: 'gray',
    fontSize: 16,
    '&:focus': {
      borderRadius: 5,
      outline: 'none !important',
      border: '2px solid black',
      backgroundColor: 'transparent',
    },
  },
}));

function StepTwo(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const symptomsForStepTwo = useSelector(
    (state) => state.selfDiagnosisReducer.symptomsForStepTwo
  );
  // const [disease, setDisease] = React.useState([]);
  const result = useSelector((state) => state.selfDiagnosisReducer.result);

  const onChangeDiesase = (e) => {
    dispatch(setDisease(e.target.value));
    // setHistory(e.target.value);
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ textAlign: 'center', marginTop: 25 }}>
          <Select
            fullWidth
            multiple
            variant="standard"
            disableUnderline
            classes={{
              root: classes.input,
            }}
            placeholder="Medical History"
            value={result}
            renderValue={(selected) =>
              selected.map((el) => el.symptom).join(', ')
            }
            onChange={onChangeDiesase}
          >
            {symptomsForStepTwo.map((symptom, index) => (
              <MenuItem
                disabled={result.length >= 1 && result.indexOf(symptom) <= -1}
                value={symptom}
                key={index}
              >
                <Checkbox checked={result.indexOf(symptom) > -1} />
                <span>{symptom.symptom}</span>
              </MenuItem>
            ))}
          </Select>
          <div
            style={{
              color: 'gray',
              fontSize: 14,
              maxWidth: 500,
              textAlign: 'left',
              marginTop: 10,
            }}
          >
            Select only 1 symptom
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default StepTwo;
